module.exports = __webpack_public_path__ + "media/images/icon/ico_top_mv01-80daa94b0e8cfd1c4c73b70f61742137.svg";